<template>
	<div class="yt">
		<div class="phonenum">
			<el-input class="phone-input" v-model="phone" placeholder="请输入手机号码"></el-input>
			<div ref="captcha"   class="yidunde"></div>
		</div>
		<div class="password">
			<el-input class="password-input" v-model="password" placeholder="请输入验证码"></el-input>
			
			<div  v-show="show" class="yzm" @click="loginIdentifyingCode">获取验证码</div>
			
		
				<div v-show="!show" class="yzm" disabled>{{count}}秒重新获取</div>
			
		</div>
		<div class="denglu" @click="codelogin(guid,subjectChoose.AppEName,subjectChoose.Name,subjectChoose.AppID,ac)"
		v-if="this.phone.length>=11  && this.password.length!=0">登录</div>
		<div class="denglu-a" 
		v-if="(this.phone.length<11 && this.password.length==0) || (this.phone.length>=11 && this.password.length==0)">登录</div>
		<div class="biao">注册即表示您同意<span class="xieyi">《考试宝典使用协议》、</span><span class="zhengce">《隐私政策》</span></div>
	</div>
</template>

<script>
	var that;
	import { sendlogincode, checkUser, sendcode, codelogin,insertBuriedPoint,setusersource } from "../api/api.js";
	export default{
		data(){
			return{
				validate:'',
				phone:'',
				password:'',
				show: true,
				count: "",
				timer: null,
				exist: true,
				guid:'',
				subjectChoose:'',
				ac:'',
			}
		},
		created() {
			this.guid=JSON.parse(localStorage.getItem('loginData')).guid;
			this.subjectChoose = JSON.parse(sessionStorage.getItem("subjectChoose"));
			this.ac=JSON.parse(localStorage.getItem('agent')).slbs
		},
		mounted() {
			that=this;
			var options = {
			  element: this.$refs.captcha,
			  captchaId: "9eb25e37fcd34904914c9986b1b0e265",
			  mode: "popup",
			  width: "100px",
			
			};
			var captchaIns;
			var that = this;
			
				
			
				initNECaptcha(
				 
				  {
				    element: this.$refs.captcha,
				    captchaId: "9eb25e37fcd34904914c9986b1b0e265",
				    mode: "popup", // 仅智能无感知验证码时，mode 才能设置为 bind
				    width: "100px",
					
				    enableClose: true, // 由业务方控制验证码弹框关闭
				    // feedbackEnable: false, // 业务方关闭反馈入口
				    onVerify: function(err, data) {
						
				      // 用户验证码验证成功后，进行实际的提交行为
				      console.log("9999", data);
				      that.validate = data.validate;
				      // todo
				      if (!err) {
				        //验证成功后，调用close方法关闭弹框（enableClose为true时调用）
				        captchaIns.close();
				        console.log("222222", captchaIns);
				      }
				    }
					
				  },
				
				  function(instance) {
					 
				    // 初始化成功后得到验证实例instance，可以调用实例的方法
				    // 禁止在初始化后立即调用instance.verify，详情参见常见问题-前端接入问题
				    captchaIns = instance;
				  },
				  function(err) {
				    // 初始化失败后触发该函数，err对象描述当前错误信息
				  }
				);
		},
		methods:{
			//登录获取验证码
			loginIdentifyingCode() {
					
			  console.log(this.validate);
			  var data = {
			    phone: this.phone,
			    agentCode: "300089-1",
			    op: "regist",
			    isRepeat: "0",
			    captchaId: "9eb25e37fcd34904914c9986b1b0e265",
			    validate: this.validate,
			    clienttype: "免费课程pc",
			    os: "Android原生"
			  };
			  var getdata = {
			    userName: this.phone,
			    agentCode: JSON.parse(localStorage.getItem('agent')).slbs
			  };
			  console.log("phone", this.userName);
			  var sendcodeDta = {
			    phone: this.userName,
			    agentCode: "300089-1",
			    op: "regist",
			    isRepeat: "0",
			    product: "考试宝典",
			    captchaId: "9eb25e37fcd34904914c9986b1b0e265",
			    validate: this.validate
			  };
			  console.log("sendcodeDta", sendcodeDta);
			  var that = this;
			  //检查账号是否已注册
			  checkUser(getdata).then(res => {
			    if (res.data.status == 201 && res.data.msg == "该用户未注册") {
			      //  this.$toast.success('成功文案');
			      that.exist = false;
			      console.log("shibai");
			    } else if (res.data.status == 200 && res.data.msg == "该用户已注册") {
			      console.log("chenggong");
			      that.exist = true;
			    }
			    console.log("getdata", res);
			  });
			  //注册登录时发送手机验证码
			  if (this.phone.length < 11 || this.phone.length == 0) {
			    // this.$toast("请输入正确的手机号");
					  // this.$refs.toast.showToast('请输入正确的手机号')
					  this.$message({
					         message: '请输入正确的手机号',
					         type: 'warning'
					       });
			  } else if (this.validate.length == 0) {
			    // this.$toast("请完成手机号验证");
					  // this.$refs.toast.showToast('请完成手机号验证')
					  this.$message({
					         message: '请完成手机号验证',
					         type: 'warning'
					       });
			  } else {
			    //倒计时
			    const TIME_COUNT = 60;
			    if (!this.timer) {
			      this.count = TIME_COUNT;
			      this.show = false;
			      this.timer = setInterval(() => {
			        if (this.count > 0 && this.count <= TIME_COUNT) {
			          this.count--;
			        } else {
			          this.show = true;
			          clearInterval(this.timer);
			          this.timer = null;
			        }
			      }, 1000);
			    }
			    // sendcode(sendcodeDta).then((res) => {
			    //   console.log("duanxinyanzheng", res);
			    //   this.$toast("短信验证码已发送");
			    // });
			    sendlogincode(data).then(res => {
			      console.log("我是验证码的", res);
			    });
			  }
			},
		//获取短信验证码登录
		codelogin(guid,AppEName,Name,AppID,ac) {
		  var data = {
		    userName: this.phone,
		    verifyCode: this.password,
		    agentCode: JSON.parse(localStorage.getItem('agent')).slbs,
		    password: this.$md5("12345678")
		  };
		  var that = this;
		  codelogin(data).then(res => {
		    if (res.data.status == "200") {
		      localStorage.setItem("loginData", JSON.stringify(res.data.data));
		      sessionStorage.setItem("username", that.phone);
		      sessionStorage.setItem("logging", 1);
			//   window.open('https://ks.ksbao.com/','_blank')
		      console.log(this.$store.state.longinData);
			  this.$emit("login",JSON.stringify(res.data.data));
			  console.log('guid',"http://bywide.ksbao.com/hzsWay?token="+res.data.data.guid+"&appEName="+AppEName+"&appName="+Name+'&appID='+AppID+'&ac='+ac+'&toUrl=speakPoint' )
			  if(res.data.data.isnewuser=="1"){
				  console.log("6666666666666")
				  var source={
				  				  userID:res.data.data.userID,
				  				  source:"免费课程"
				  }
				  setusersource(source).then(res=>{
				  				  console.log("注册来源",res.data)
				  })
			  }
			
		
			  this.$router.replace({path: '/login'})
			  //跳转到考试宝典
			  window.location.replace("http://bywide.ksbao.com/hzsWay?token="+res.data.data.guid+"&appEName="+AppEName+"&appName="+Name+"&vn=0"+'&appID='+AppID+'&ac='+ac+'&toUrl=speakPoint') 
			
		    
		    } else {
	
			     this.$message({
			            message: '手机号或手机验证码错误',
			            type: 'warning'
			          });
		    }
		  });
		
		},
		}
	}
</script>

<style scoped="scoped">
	.yt /deep/ .el-dialog__header{
		padding: 20px 20px  10px;
	}
	.yt /deep/ .el-dialog__title{
		font-weight: 700;
		color: #6ec1fd;
		font-size: 25px;
	}
	.yt /deep/ .yidun_intellisense--light .yidun_intelli-icon{
		display: none;
	}
	.yt /deep/ .yidun_intellisense--light .yidun_intelli-control{
		border: 1px solid #8ac3fe;
		background-color: #ffffff;
		height: 35px;
	}
	.yt /deep/ .yidun_intellisense--light .yidun_intelli-text{
		line-height: 35px;
		color: #8ac3fe;
	}
	.yt /deep/ .yidun_intellisense--light.yidun_intellisense--success .yidun_classic-tips{
		
		line-height: 35px;
		border: none;
	}
	.yt /deep/ .yidun_intellisense--light.yidun_intellisense--success .yidun_intelli-control {
		border: none;
	}
	.yt /deep/ .el-input__inner{
		border: none;
		outline: none;
		padding: 0;
		font-size: 16px;
	}
	.phonenum{
		display: flex;
		flex-direction: row;
		width: 65%;
		height: 50px;
		border-bottom: 2px solid #efeeee;
		margin: auto;
		margin-bottom: 20px;
	}
	.phone-input{
		margin-top: 10px;
		width: 68%;
		
	}
	.yidunde{
		width: 120px;
		height: 35px;
	   margin-top: 9px;
	}
	.password{
		display: flex;
		flex-direction: row;
		width: 65%;
		height: 50px;
		border-bottom: 2px solid #efeeee;
		margin: auto;
		margin-bottom: 30px;
	}
	.password-input{
		margin-top: 10px;
		width: 68%;
		
	}
	.yzm{
		width: 118px;
		height: 33px;
		text-align: center;
		line-height: 33px;
		margin-top: 9px;
		color: #8ac3fe;
		border-radius: 2px;
		border: 1px solid #8ac3fe;
	}
	.denglu{
		width: 65%;
		height: 45px;
		font-size: 18px;
		text-align: center;
		line-height: 45px;
		color: #ffffff;
		/* border: 1px solid #797979; */
		background-color: #5bb8ff;
		margin: auto;
		border-radius: 5px;
		cursor: pointer;
	}
	.denglu-a{
		width: 65%;
		height: 45px;
		font-size: 18px;
		text-align: center;
		line-height: 45px;
		color: #ffffff;
		/* border: 1px solid #797979; */
		background-color: #5bb8ff;
		margin: auto;
		border-radius: 5px;
		cursor: pointer;
		opacity: 0.8;
	}
	.biao{
		width: 100%;
		height: 30px;
		margin-top: 30px;
		text-align: center;
		margin-bottom: 20px;
	}	
	.xieyi{
		color: #8ac3fe;
	}
	.zhengce{
		color: #8ac3fe;
	}
</style>
